<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kunde erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.customers.store'))">
                <form-fields 
                    :form="form" 
                    :countries="countries" 
                    :customer-groups="customerGroups" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'customerGroups',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    account_type: null,
                    customer_group_id: null,
                    customer_number: null,
                    slug: null,
                    logo: null,
                    short_name: null,
                    street: null,
                    house_number: null,
                    zip_code: null,
                    city: null,
                    country_id: null,
                    default_category_id: null,
                    phone: null,
                    fax: null,
                    email: null,
                    vat_id: null,
                    website: null,
                    description: null,
                    notes: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>